import React from 'react';
import PropTypes from 'prop-types';
import {PROPTYPE_SPOT_ID} from 'proptypes';
import {Box} from '@spothero/ui';

const SpotListItemBase = ({
    spotId,
    additionalClasses,
    MainContent,
    onMouseEnter,
    onMouseLeave,
    onClick,
}) => {
    return (
        <div
            className={`SpotListItem result${spotId} ${additionalClasses}`}
            data-spot={spotId}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
        >
            <Box height="100%">{MainContent}</Box>
        </div>
    );
};

SpotListItemBase.propTypes = {
    spotId: PROPTYPE_SPOT_ID.isRequired,
    additionalClasses: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onClick: PropTypes.func,
    MainContent: PropTypes.node,
};

export default SpotListItemBase;
